import { TwoFactorModalContainer } from '~/_shared/components/accountSettings/twoFactorModal/twoFactorModal.container';
import { modalRenderer } from '~/modal/modalRendererRegistry';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    TwoFa: undefined;
  }
}

modalRenderer.register('TwoFa', TwoFactorModalContainer);
